import React from "react";
import { Helmet } from "react-helmet-async";
import { kirkos_logo_white_yellow } from "../../assets/images";

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogUrl?: string;
  twitterHandle?: string;
  canonicalUrl?: string;
  schemaData?: object;
}

const SEO: React.FC<SEOProps> = ({
  title = "Kirkos | Premium Car Rental Services",
  description = "Rent luxury and premium cars with Kirkos. Fast, reliable, and convenient car hire services tailored to your needs.",
  keywords = "car rental, car hire, luxury car rental, Kirkos car hire, premium car hire",
  ogTitle,
  ogDescription,
  ogImage = kirkos_logo_white_yellow,
  ogUrl = "https://kirkos.ae",
  // twitterHandle = "@KirkosCarRental",
  canonicalUrl,
  schemaData,
}) => {
  const siteTitle = title.includes("Kirkos") ? title : `${title} | Kirkos`;

  return (
    <Helmet>
      {/* Standard Metadata */}
      <title>{siteTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Canonical Link */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:title" content={ogTitle || siteTitle} />
      <meta property="og:description" content={ogDescription || description} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      {/* <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={ogUrl} />
      <meta name="twitter:title" content={ogTitle || siteTitle} />
      <meta name="twitter:description" content={ogDescription || description} />
      <meta name="twitter:image" content={ogImage} />
      {twitterHandle && <meta name="twitter:site" content={twitterHandle} />} */}

      {/* JSON-LD Structured Data */}
      {schemaData && (
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
